<template>
  <div>
    <a-input-search v-model="searchValue" class="mb8" @change="handlerChange" placeholder="搜索" />
    <a-tree
      :blockNode="true"
      ref="treeData"
      @select="onSelectTree"
      :show-icon="true"
      :defaultExpandAll="true"
      :replaceFields="{
        children: 'childStructure',
        title: 'departmentName',
        key: 'bussinessNo',
      }"
      :tree-data="treeDataList"
      v-model="checkedKeys"
      :expanded-keys="expandedKeys"
      :auto-expand-parent="autoExpandParent"
      @expand="onExpand"
    >
      <template slot="icon" slot-scope="item">
        <a-icon v-if="item.level===3" type="team"></a-icon>
      </template>
      <template slot="title" slot-scope="item">
        <span class="w100-pc">
          <span :class="item.level===3?'leftItem':'leftItem1'" v-if="item.title.indexOf(searchValue) > -1">
            {{ item.title.substr(0, item.title.indexOf(searchValue)) }}
            <span class="color-f50">{{ searchValue }}</span>
            <span :title="item.title.substr(item.title.indexOf(searchValue) + searchValue.length)">
              {{ item.title.substr(item.title.indexOf(searchValue) + searchValue.length) }}
            </span>
          </span>
          <span :class="item.level===3?'leftItem':'leftItem1'" v-else :title="item.title">{{ item.title }}</span>
        </span>
      </template>
    </a-tree>
  </div>
</template>
<script>

import { getOrganizationTree } from '@/api/system/businessGroup'
import deepClone from "lodash.clonedeep";
import debounce from "lodash.debounce";
export default {
  name: 'NavTree',
  props: {
    // treeData:{
    //   type:Array,
    //   default:()=>{
    //     return []
    //   }
    // },
    customBussinessNo: {
      type: String,
      default: 'YJLX0001'
    }
  },

  data () {
    return {
      selectedKeys: [],
      copyTreeData: [],
      dataList: [],
      treeData: [],
      autoExpandParent: true,
      expandedKeys: [],
      checkedKeys: [],
      searchValue: ''
    }
  },
  computed: {
    treeDataList () {
      const listObj = this.treeData.find(item => item.bussinessNo === this.customBussinessNo)
      return listObj?.childStructure
    }
  },
  created () {},
  mounted () {
    this.handlerTreeData()
    this.copyTreeData = deepClone(this.treeData);
  },
  methods: {
    // 获取数据
    handlerTreeData () {
      getOrganizationTree().then(res => {
        if (res.code === 200) {
          const treeDataArr = res.rows;
          treeDataArr.forEach((item) => {
            item.id = "business_" + item.bussinessNo;
            item.selectable = item.level !== 1 // 第一层级的菜单不可选
          });
          this.getDataList(treeDataArr);
          this.treeData = treeDataArr;
          this.copyTreeData = deepClone(this.treeData);
        }
      })
    },
    // 获取数据列表
    getDataList (data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.id;
        node.scopedSlots = { title: "title", icon: "icon" };
        node.key = node.id;
        node.title = node.departmentName;
        node.children = node.childStructure;
        this.dataList.push({
          key,
          title: node.departmentName,
          parentId: node.parentBussinessNo,
          ...node
        });
        if (node.childStructure) {
          this.getDataList(node.childStructure);
        }
      }
    },
    handlerChange: debounce(function (e) {
      this.treeData = deepClone(this.copyTreeData);
      const findExpendKeyTree = deepClone(this.copyTreeData);
      const value = e.target.value;
      if (value === "") {
        this.expandedKeys = [];
        this.searchValue = '';
        return;
      }
      const recursionResult = this.recursionFilterTreeData(findExpendKeyTree, value);
      this.treeData = recursionResult[0];
      const expandedKeys = Array.from(recursionResult[2]); // 需要展开的节点id
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    }, 500),
    /**
     * @description 递归过滤treeData
     * @return {[*,*]} 返回一个三元数组，第一个为过滤后的数组，第二个为未过滤数组，第三个为搜索目标的父级id集合Set
     */
    recursionFilterTreeData (treeNodes, value) {
      if (treeNodes && treeNodes.length > 0) {
        const newTreeNodes = [];
        let expendKeySet = new Set();
        treeNodes.forEach(treeNode => {
          const recursionResult = this.recursionFilterTreeData(treeNode.childStructure, value);
          treeNode.childStructure = recursionResult[0];
          expendKeySet = new Set([...recursionResult[2], ...expendKeySet])
          if (treeNode.childStructure && treeNode.childStructure.length > 0) {
            newTreeNodes.push(treeNode);
          } else if (treeNode.departmentName.indexOf(value) > -1) {
            expendKeySet.add(treeNode.parentBussinessNo);
            newTreeNodes.push(treeNode);
          }

          if (treeNode.departmentName.indexOf(value) > -1) { // 如果目录符合搜索条件，则不对children进行过滤
            treeNode.childStructure = recursionResult[1];
          }
        });
        return [newTreeNodes, treeNodes, expendKeySet];
      } else {
        return [treeNodes, treeNodes, new Set()];
      }
    },
    // 子分类展开
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelectTree (value, event) {
      if (value.length > 0) {
        this.$emit('onSelectTree', { value: value[0], level: event?.selectedNodes[0]?.data?.props?.level, showIs: false, props: event?.selectedNodes[0]?.data?.props });
      }
    }
  }
}
</script>

<style lang="less" scoped>
 .leftItem{
   width: calc( 100% - 40px);
   display: inline-block;
   overflow:hidden;
   text-overflow:ellipsis;
   white-space: nowrap;
 }
 .leftItem1{
   width: calc( 100% - 16px);
   display: inline-block;
   overflow:hidden;
   text-overflow:ellipsis;
   white-space: nowrap;
 }
 .rightItem{
   width: 20px;
   display: inline-block;
   vertical-align: top;
   text-align: center;
   z-index: 9;
   color:#7A808A;
   &:hover{
     border-radius: 3px;
     background: #DEE5F7;
     cursor: pointer
   }
 }
 .plusText{
   color:#299bff
 }
 .mb8 {
  margin-bottom: 8px
 }
 .color-f50 {
  color: #f50
 }
</style>
